// extracted by mini-css-extract-plugin
export default {"title":"AdminUsers_title__cfU2P","row-breadcrumb":"AdminUsers_row-breadcrumb__5J7vY","row-contas":"AdminUsers_row-contas__y61xk","buttons":"AdminUsers_buttons__RHRSa"};